import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable';
import {
	ExtendedColumnDef,
	useMantineTableWithPaginationFilteringSorting,
} from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import {
	GetSecurityEventsRes,
	SecurityEventFilterDto,
	SecurityEventRes,
} from '@dealstack/shared/lib/generated';
import { LegacyRef, memo } from 'react';

const EMPTY_SECURITY_EVENTS: SecurityEventRes[] = [];

type MantineTableDataOperationsType = ReturnType<
	typeof useMantineTableWithPaginationFilteringSorting<SecurityEventRes, SecurityEventFilterDto>
>['mantineTableDataOperations'];

interface Props {
	securityEvents?: GetSecurityEventsRes;
	eventColumns: ExtendedColumnDef<SecurityEventRes>[];
	isTableLoading: boolean;
	tableRef: LegacyRef<HTMLDivElement>;
	mantineTableDataOperations: MantineTableDataOperationsType;
}

const SecurityEvents = ({
	securityEvents,
	eventColumns,
	isTableLoading,
	tableRef,
	mantineTableDataOperations,
}: Props) => {
	return (
		<MantineTable
			getRowId={(row) => row.id}
			enableColumnResizing={true}
			mantineTableBodyRowProps={({ row }) => ({
				id: row.id,
				sx: {
					cursor: 'pointer',
				},
			})}
			mantineTableBodyProps={() => ({
				sx: {
					'& .mantine-Text-root': {
						maxWidth: '100%',
					},
				},
			})}
			tableRef={tableRef}
			columns={eventColumns}
			isLoading={isTableLoading}
			dataOperations={mantineTableDataOperations}
			manualPagination
			data={securityEvents?.securityEvents ?? EMPTY_SECURITY_EVENTS}
			rowCount={securityEvents?.totalCount ?? 0}
			initialState={{
				columnVisibility: {
					id: false,
					preEventUnits: false,
					postEventUnits: false,
					postEventNominalValue: false,
				},
			}}
			enableRowActions={false}
			enableRowSelection={false}
			enableSearchBar={false}
			enableTopToolbar
		/>
	);
};

const Memoized = memo(SecurityEvents);

export { Memoized as SecurityEvents };
